export const CHARACTER_COLORS = ["#8A61FB", "#21ADAA", "#DD7B8A", "#04B8F5"];
